// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"7b57e6f4","132":"cfaa387b","453":"d855a71b","751":"c03217df"}[chunkId] + ".chunk.js";
};